import React from "react"
import { Link } from "react-router"

export default function Home() {
    return (

        <div className="bg-zinc-950 text-white font-sans">
            {/* Navbar */}
            <nav className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/80 backdrop-blur-lg border-b border-zinc-800">
                <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-3 cursor-pointer">
                        <div className="w-8 h-8 bg-violet-900 rounded-xl flex items-center justify-center text-white font-bold text-xl">A</div>
                        <span className="text-2xl font-semibold tracking-tight">AetherForge-Workspace</span>
                    </div>

                    <div className="flex items-center gap-4">
                    <Link to='/pricing' >
                            <button className="px-8 border border-violet-700 rounded cursor-pointer py-2 text-xl font-medium hover:text-violet-400 transition-colors">
                                Pricing
                            </button>
                        </Link>
                        <Link to='/login' >
                            <button className="px-6 cursor-pointer py-2 text-sm font-medium hover:text-violet-400 transition-colors">
                                Sign in
                            </button>
                        </Link>
                        <Link to='/register' >
                            <button className="px-6 cursor-pointer py-2 bg-white text-zinc-900 rounded-2xl font-semibold hover:bg-violet-500 hover:text-white transition-all">
                                Register
                            </button>
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <section className="pt-24 pb-16 bg-gradient-to-b from-zinc-950 via-violet-950/30 to-zinc-950">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center max-w-3xl mx-auto">
                        <div className="inline-flex items-center gap-2 bg-zinc-900 border border-zinc-700 rounded-full px-4 py-1.5 text-sm mb-6">
                            <span className="text-emerald-400">●</span>
                            Now in Public Beta
                        </div>
                        <h1 className="text-6xl md:text-7xl font-bold leading-tight tracking-tighter mb-6">
                            {/* AI-driven tools for<br />product teams */}
                            AI-Powered<br />
                            Collaborative Workspace
                        </h1>
                        <p className="text-xl text-zinc-400 mb-10">
                            {/* Our landing page template works on all devices, so you only have to set it up once,<br />
                            and get beautiful results forever. */}
                            Build, manage, and ship projects faster with real-time collaboration,
                            AI assistance, and intelligent task management.
                        </p>

                        <div className="flex items-center justify-center gap-4">
                            <Link to='/register' >
                                <button className="px-8 py-4 bg-violet-900 cursor-pointer hover:bg-violet-500 rounded-3xl font-semibold flex items-center gap-2 transition-all">
                                    Start Building →
                                </button>
                            </Link>
                            <Link to='/login' >
                                <button className="px-8 py-4 border border-zinc-700 cursor-pointer hover:border-zinc-400 rounded-3xl font-medium transition-all">
                                    Sign in
                                </button>
                            </Link>

                        </div>
                    </div>

                    {/* Hero Image */}
                    <div className="mt-16 rounded-3xl overflow-hidden border border-zinc-800 shadow-2xl">
                        <img
                            src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=600&fit=crop"
                            alt="Team working"
                            className="w-full h-auto object-cover"
                        />
                    </div>
                </div>
            </section>

            {/* Tailored Workflows */}
            <section className="py-20 bg-zinc-950">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-semibold mt-2 mb-4">Built for modern product teams</h2>
                        <p className="text-violet-400 text-sm font-medium tracking-widest">Everything you need to collaborate effectively.</p>
                        {/* <p className="text-zinc-400 max-w-xl mx-auto">Everything you need to collaborate effectively.</p> */}
                    </div>

                    <div className="grid md:grid-cols-3 gap-8 cursor-pointer">
                        <div className="bg-zinc-900/50 border border-zinc-800 rounded-3xl p-8 hover:border-violet-500 transition-all">
                            <div className="text-4xl mb-6">📊</div>
                            <h3 className="text-2xl font-semibold mb-3">Real-time Kanban</h3>
                            <p className="text-zinc-400">Drag & drop tasks with live updates across your team.</p>
                        </div>

                        <div className="bg-zinc-900/50 border border-zinc-800 rounded-3xl p-8 hover:border-violet-500 transition-all">
                            <div className="text-4xl mb-6">🤖</div>
                            <h3 className="text-2xl font-semibold mb-3">AI Forge Assistant</h3>
                            <p className="text-zinc-400">Get intelligent suggestions, task breakdowns, and project ideas.</p>
                        </div>

                        <div className="bg-zinc-900/50 border border-zinc-800 rounded-3xl p-8 hover:border-violet-500 transition-all">
                            <div className="text-4xl mb-6">👥</div>
                            <h3 className="text-2xl font-semibold mb-3">Smart Collaboration</h3>
                            <p className="text-zinc-400">Member management, role-based access, and real-time presence.</p>
                        </div>
                    </div>

                 
                </div>
            </section>

            {/* Built for modern product teams */}
            <section className="py-20 bg-zinc-900">
                <div className="max-w-7xl mx-auto px-6 text-center">

                    <p className="text-violet-400 text-sm font-medium tracking-widest">TAILORED WORKFLOWS</p>
                    <h2 className="text-4xl font-semibold mt-2">Map your product journey</h2>

                    {/* Central Diagram (simplified) */}
                    <div className="my-16 flex justify-center">
                        <div className="flex items-center gap-8 bg-zinc-950 border border-zinc-700 rounded-3xl px-12 py-8">
                            <div className="text-center">
                                <div className="text-xs font-medium text-zinc-500">PLAN</div>
                            </div>
                            <div className="h-px w-12 bg-gradient-to-r from-transparent via-violet-500 to-transparent"></div>
                            <div className="text-center">
                                <div className="text-xs font-medium text-zinc-500">TEAM</div>
                            </div>
                            <div className="h-px w-12 bg-gradient-to-r from-transparent via-violet-500 to-transparent"></div>
                            <div className="text-center bg-violet-600 text-white px-6 py-3 rounded-2xl font-semibold">PROJECTS</div>
                            <div className="h-px w-12 bg-gradient-to-r from-transparent via-violet-500 to-transparent"></div>
                            <div className="text-center">
                                <div className="text-xs font-medium text-zinc-500">TASKS</div>
                            </div>
                            <div className="h-px w-12 bg-gradient-to-r from-transparent via-violet-500 to-transparent"></div>
                            <div className="text-center">
                                <div className="text-xs font-medium text-zinc-500">EXECUTE</div>
                            </div>
                        </div>
                    </div>

                    {/* 6 Feature Cards */}
                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="bg-zinc-950 border border-zinc-800 rounded-3xl p-6 hover:scale-105 transition-all">Workspace Collaboration</div>
                        <div className="bg-zinc-950 border border-zinc-800 rounded-3xl p-6 hover:scale-105 transition-all">Team Engagement Metrics</div>
                        <div className="bg-zinc-950 border border-zinc-800 rounded-3xl p-6 hover:scale-105 transition-all">AI Forge Assistant</div>
                        <div className="bg-zinc-950 border border-zinc-800 rounded-3xl p-6 hover:scale-105 transition-all">Personalized AI Suggestions</div>
                        <div className="bg-zinc-950 border border-zinc-800 rounded-3xl p-6 hover:scale-105 transition-all">Kanban Taskflow Management</div>
                        <div className="bg-zinc-950 border border-zinc-800 rounded-3xl p-6 hover:scale-105 transition-all">Streamlined Project Development</div>
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            {/* <section className="py-20 bg-zinc-950">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-center text-4xl font-semibold mb-12">Don't take our word for it</h2>
                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8">
                            <p className="italic text-zinc-300">"AetherForge has completely transformed how our team collaborates."</p>
                            <div className="mt-8 flex items-center gap-3">
                                <div className="w-10 h-10 bg-zinc-700 rounded-2xl"></div>
                                <div>
                                    <div className="font-medium">Sarah Chen</div>
                                    <div className="text-sm text-zinc-500">Product Lead, Stripe</div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8">
                            <p className="italic text-zinc-300">"AetherForge has completely transformed how our team collaborates."</p>
                            <div className="mt-8 flex items-center gap-3">
                                <div className="w-10 h-10 bg-zinc-700 rounded-2xl"></div>
                                <div>
                                    <div className="font-medium">Sarah Chen</div>
                                    <div className="text-sm text-zinc-500">Product Lead, Stripe</div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8">
                            <p className="italic text-zinc-300">"AetherForge has completely transformed how our team collaborates."</p>
                            <div className="mt-8 flex items-center gap-3">
                                <div className="w-10 h-10 bg-zinc-700 rounded-2xl"></div>
                                <div>
                                    <div className="font-medium">Sarah Chen</div>
                                    <div className="text-sm text-zinc-500">Product Lead, Stripe</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* Final CTA */}
            <section className="py-20 bg-gradient-to-b from-zinc-950 to-violet-950 text-center">
                <h2 className="text-5xl font-semibold mb-6">Ready to build better together?</h2>
                <p className="text-zinc-400 text-xl mb-10">
                    Join thousands of developers and teams using AetherForge to ship faster.
                </p>
                <div className="flex justify-center gap-4">
                    <Link to='/register' >
                        <button className="px-8 py-4 bg-violet-900 cursor-pointer hover:bg-violet-500 rounded-3xl font-semibold flex items-center gap-2 transition-all">
                            Start Building →
                        </button>
                    </Link>
                    <Link to='/login' >
                        <button className="px-8 py-4 border border-zinc-700 cursor-pointer hover:border-zinc-400 rounded-3xl font-medium transition-all">
                            Sign in
                        </button>
                    </Link>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-zinc-950 border-t border-zinc-800 py-12">
                <div className="max-w-7xl mx-auto px-6 text-zinc-400 text-sm">
                    <p className="text-center">© 2026 AetherForge • All rights reserved</p>
                </div>
            </footer>
        </div>

    )
}
